import { CircularProgress } from "@mui/material";
import { context } from "..";
import Logo from "../misc/Logo";


export default function FallbackPage () {

    var redirectUri = context.completionRedirectUri
    
    return (
        <div className="main-inner">
            <div style={{padding: "15vh 0"}}>
                <h1 style={{fontSize: "8vw", fontWeight: "800", lineHeight: "8vw"}}>Data Driven Questionnaires</h1>
                
                <h1 style={{fontWeight: "600", marginTop: "15px"}}>by <Logo width={80} type="block" /></h1>
                
                {redirectUri ? (
                    <>
                        <p>To continue to the next stage of your application, click the link below.</p>
                        <a href={redirectUri}>{redirectUri}</a>
                    </>
                ) : null}

                {redirectUri && context.redirectCountdown !== null && context.redirectCountdown > -1 ? (
                    <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                        <CircularProgress style={{width: "12px", height: "12px"}} color="secondary" />

                        <p>Redirecting you in {context.redirectCountdown}.</p>
                    </div>
                ) : null}
            </div>
        </div>
    )
}